const STATUS_CONFIG = {
  FLOODED: {
    label: "Flooded",
    bg: "bg-blue-100",
    border: "border-blue-400",
    text: "text-blue-800",
    dot: "bg-blue-500",
  },
  DRYING: {
    label: "Drying",
    bg: "bg-amber-100",
    border: "border-amber-400",
    text: "text-amber-800",
    dot: "bg-amber-500",
  },
  NEEDS_IRRIGATION: {
    label: "Needs Irrigation",
    bg: "bg-red-100",
    border: "border-red-400",
    text: "text-red-800",
    dot: "bg-red-500",
  },
  FLOWERING_SAFE: {
    label: "Flowering Safe Period",
    bg: "bg-green-100",
    border: "border-green-400",
    text: "text-green-800",
    dot: "bg-green-500",
  },
  UNKNOWN: {
    label: "Unknown",
    bg: "bg-gray-100",
    border: "border-gray-400",
    text: "text-gray-700",
    dot: "bg-gray-400",
  },
};

export default function AWDStatusCard({ awdStatus, activeCycle }) {
  if (!awdStatus) return null;

  const cfg = STATUS_CONFIG[awdStatus.awd_status] || STATUS_CONFIG.UNKNOWN;

  return (
    <div className={`rounded-xl border-2 ${cfg.border} ${cfg.bg} p-5`}>
      <div className="flex items-center gap-3 mb-3">
        <span className={`inline-block w-3 h-3 rounded-full ${cfg.dot}`} />
        <span className={`font-semibold text-lg ${cfg.text}`}>{cfg.label}</span>
      </div>

      <div className="flex items-end gap-2 mb-3">
        <span className={`text-4xl font-bold ${cfg.text}`}>
          {awdStatus.water_level_cm != null
            ? `${awdStatus.water_level_cm > 0 ? "+" : ""}${awdStatus.water_level_cm.toFixed(1)}`
            : "—"}
        </span>
        <span className={`text-lg mb-1 ${cfg.text}`}>cm</span>
      </div>

      <p className="text-sm text-gray-700 mb-2">{awdStatus.recommendation}</p>

      {activeCycle && (
        <div className="text-xs text-gray-500 mt-2 border-t border-gray-200 pt-2">
          Drying since{" "}
          {new Date(activeCycle.drying_started_at).toLocaleDateString()} (
          {activeCycle.duration_days.toFixed(1)} days)
          {activeCycle.reached_threshold ? " · threshold reached" : ""}
        </div>
      )}

      {awdStatus.last_reading_at && (
        <div className="text-xs text-gray-400 mt-1">
          Last reading: {new Date(awdStatus.last_reading_at).toLocaleString()}
        </div>
      )}
    </div>
  );
}
